import { TextField } from "@mui/material";
import type { FC } from "react";
import { Controller, useFormContext } from "react-hook-form";
import type { MomentFormMoment } from "../../../moment/types/moment-form-moment";
import type { ScheduleFormV2LayoutProps } from "./types";

export const SendAt: FC<ScheduleFormV2LayoutProps> = ({ showValidationErrors, disabled }) => {
  const { control } = useFormContext<MomentFormMoment>();

  return (
    <Controller
      name="schedule.send_at"
      control={control}
      render={({ field, fieldState }) => (
        <TextField
          type="time"
          error={Boolean(showValidationErrors && fieldState.error)}
          sx={{ width: 130, paddingLeft: 1 }}
          value={truncateSeconds(field.value)}
          onChange={(value) => field.onChange(value)}
          disabled={disabled}
        />
      )}
    />
  );
};

const truncateSeconds = (time: string): string => {
  const parts = time.split(":");
  return parts.slice(0, 2).join(":");
};
